import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PREVENTIVE_TASK_ASSIGNEE_PATH } from '../../../../config/paths';

import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';

import Content from '../../../layout/Content';
import PreventiveTaskAssigneeForm from './PreventiveTaskAssigneeForm';

import { postPreventiveTaskAssignee } from '../../../../actions/task-schedule/PreventiveTaskAssignee';

import { PREVENTIVE_TASK_ASSIGNEE_SCOPE } from '../../../../config/constants';

const getSelectValue = (field) => {
  if (field && typeof field === 'object') {
    return field.value;
  }

  return field;
};

const getSelectLabel = (field) => {
  if (field && typeof field === 'object') {
    return field.label;
  }

  return null;
};

const getSelectedTaskIds = (preventiveTaskIds) => {
  if (!Array.isArray(preventiveTaskIds)) {
    const singleTaskId = getSelectValue(preventiveTaskIds);

    return singleTaskId ? [singleTaskId] : [];
  }

  return [
    ...new Set(
      preventiveTaskIds
        .map(getSelectValue)
        .filter(
          (taskId) => taskId !== undefined && taskId !== null && taskId !== '',
        ),
    ),
  ];
};

const buildPreventiveTaskAssigneeBody = (formValues) => {
  const assignmentScope = getSelectValue(formValues.assignmentScope);

  const preventiveTaskIds = getSelectedTaskIds(formValues.preventiveTaskIds);

  const departmentId = getSelectValue(formValues.departmentId);

  const departmentName = getSelectLabel(formValues.departmentId);

  const areaId = getSelectValue(formValues.areaId);

  const areaName = getSelectLabel(formValues.areaId);

  const positionId = getSelectValue(formValues.positionId);

  const positionName = getSelectLabel(formValues.positionId);

  const userId = getSelectValue(formValues.userId);

  return {
    preventiveTaskIds,

    assignmentScope,

    departamentId: departmentId,
    departamentName: departmentName,

    areaId,
    areaName,

    positionId:
      assignmentScope === PREVENTIVE_TASK_ASSIGNEE_SCOPE.ROLE.value
        ? positionId
        : null,

    positionName:
      assignmentScope === PREVENTIVE_TASK_ASSIGNEE_SCOPE.ROLE.value
        ? positionName
        : null,

    userId:
      assignmentScope === PREVENTIVE_TASK_ASSIGNEE_SCOPE.PERSON.value
        ? userId
        : null,
  };
};

const initialValues = {
  preventiveTaskIds: [],
  assignmentScope: null,
  organizationId: 1,
  departmentId: null,
  areaId: null,
  positionId: null,
  userId: null,
};

const NewPreventiveTaskAssignee = ({
  breadcrumbs,
  dispatchPostPreventiveTaskAssignee,
  loading,
}) => {
  const onSubmit = (formValues) => {
    const body = buildPreventiveTaskAssigneeBody(formValues);

    /*
     * Una sola petición con todas las tareas.
     */
    return dispatchPostPreventiveTaskAssignee(body);
  };

  const content = (
    <PreventiveTaskAssigneeForm
      onSubmit={onSubmit}
      initialValues={initialValues}
      loading={loading}
    />
  );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nueva Asignación de Tareas Programadas"
      subtitle="Asignar varias tareas programadas a una misma área, rol o personal"
      content={content}
    />
  );
};

NewPreventiveTaskAssignee.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,

  dispatchPostPreventiveTaskAssignee: PropTypes.func.isRequired,

  loading: PropTypes.bool.isRequired,
};

const mapDispatchToProps = {
  dispatchPostPreventiveTaskAssignee: postPreventiveTaskAssignee,
};

const mapStateToProps = ({ TaskScheduleUnit }) => ({
  breadcrumbs: [
    ...TaskScheduleUnit.UnitHome.get('breadcrumbs'),

    {
      text: 'Lista de Asignaciones Tareas Programadas',
      href: PREVENTIVE_TASK_ASSIGNEE_PATH,
    },

    {
      text: 'Nueva Asignación',
      href: '',
    },
  ],

  loading: !TaskScheduleUnit.PreventiveTaskAssignee.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewPreventiveTaskAssignee);
